import Card from 'react-bootstrap/Card';
import PopUpModal from './socionics/cards/PopupModal';
import { useState } from 'react';
function InfoCard(props) {
  const [showStress, setShowStress] = useState(false);
  function setStress() {
    setShowStress(!showStress);
  }
  return (
    <Card style={props.style} bg={props.color}>
      <Card.Header>
        {props.head}
        {props.scale && <button className='rounded float-end' style={{ fontSize: '13px' }} onClick={props.handleClick}>Show Scale</button>}
        {props.adapt &&
          <button className='rounded float-end' style={{ fontSize: '13px', background: 'black', color: 'white' }} onClick={setStress}>
            <PopUpModal
              item={'Stress Factors'}
              heading={'Stress Factors'}
              bullets={props.bodyStress}
              action={props.action}
              help={props.help}
              stress={'true'}
              />
          </button>}
      </Card.Header>
      <Card.Body>
        {props.body}
        <ul>
          {props.list && props.list.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
        <Card.Text>

        </Card.Text>
      </Card.Body>
      <Card.Footer></Card.Footer>
    </Card>
  );
}

export default InfoCard;
